import {POPUP} from "/@back@/commons/widgets/popups.js";
import {Desk} from "/@lib@/commons/desk.js";

export const CLIPBOARD = {

	get hasCustomType(): boolean {
		//Aucune autre solution trouvée pour détecter la fonctionnalité Async clipboard Custom Types (https://developer.chrome.com/blog/web-custom-formats-for-the-async-clipboard-api/).
		if (hasCustomType === undefined) hasCustomType = Desk.navVersions["Chrome"] >= 104;
		return hasCustomType;
	},


	async writeInClipboard(copy: () => Promise<void>, from: HTMLElement) {
		try {
			await copy();
		} catch (e) {
			POPUP.showNotifError("Le contenu n'a pas pu être copié dans le presse-papier. Vérifiez dans votre navigateur que vous avez autorisé ce site à accéder au presse-papier.",
				from, null, {posFrom: from, fromX: "middle", fromY: "middle", targetX: "middle", targetY: "middle"});
			console.log(e);
		}
	},

	/** Retourne un tableau non vide ou null. */
	async read(from: HTMLElement): Promise<ClipboardItem[] | null> {
		try {
			const items = await navigator.clipboard.read();
			return items?.length > 0 ? items : null; //FIX chrome 120 : peut retourner un tableau vide.
		} catch (e) {
			return this.onReadError(from, e);
		}
	},

	/**
	 * Résoud un type de ClipboardItem en string.
	 * FIX bug Chromium 113 : Si ClipboardItem créé manuellement avecun string, item.getType(type) retourne un Promise<string> et pas un Promise<Blob>
	 */
	async text(item: ClipboardItem, type: string): Promise<string | null> {
		const v = await item.getType(type);
		if (v instanceof Blob) return await v.text();
		return typeof v === "string" ? v : null;
	},

	async readText(from: HTMLElement): Promise<string | null> {
		try {
			return await navigator.clipboard.readText();
		} catch (e) {
			return this.onReadError(from, e);
		}
	},

	onReadError(from: HTMLElement, e: any): null {
		if (e instanceof DOMException) {
			if (e.name === "NotAllowedError") {
				POPUP.showNotifError(
					"Le contenu du presse-papier n'a pas pu être obtenu. Vérifiez dans votre navigateur que vous avez autorisé ce site à accéder au presse-papier.", from, null,
					{posFrom: from, fromX: "middle", fromY: "middle", targetX: "middle", targetY: "middle"}
				);
			} else if (e.name === "DataError") return null; //clipboard vide.
		}
		console.log(e);
		return null;
	}
}


let hasCustomType: boolean